import { TFunction } from "i18next";
import * as yup from "yup";

export interface EnvelopeClassificationRequestValidationSchemeProps {
    t: TFunction;
}

export const EnvelopeClassificationRequestValidationScheme = ({
    t,
}: EnvelopeClassificationRequestValidationSchemeProps) => {
    const requiredMsg = t("validations.required");

    return yup.object().shape({
        classificationMark: yup.string().nullable().required(requiredMsg),
        registryNumber: yup.string().nullable().required(requiredMsg),
        registrationDate: yup.date().required(requiredMsg).nullable()
    });

};